import { render, staticRenderFns } from "./TagsIndexFieldtype.vue?vue&type=template&id=856cea28&"
import script from "./TagsIndexFieldtype.vue?vue&type=script&lang=js&"
export * from "./TagsIndexFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports